import React, { FC } from 'react';
import { WelderProgressTreeItemContainerStyled } from '../styled';
import { Text, Box } from '@bechtel/gds';
import { UserInfo } from '~/components/organisms/user-info';
import { CommodityFilterStatusFlag, CommodityStatusStats, CrewProgressStats } from '@bechtel/types';
import { find } from 'lodash';

export interface WelderProgressTreeItemProps {
  weldStatsByPersona: CrewProgressStats;
}
export const WelderProgressTreeItem: FC<WelderProgressTreeItemProps> = ({ weldStatsByPersona }) => {
  const { crewMember, commodityStatusStats } = weldStatsByPersona;
  const getStats = (status: CommodityFilterStatusFlag) => {
    const statusStat: CommodityStatusStats = find(
      commodityStatusStats,
      (item: CommodityStatusStats) => item?.status === status
    );
    return statusStat?.status ? statusStat.stats : 0;
  };
  return (
    <WelderProgressTreeItemContainerStyled>
      <Box style={{ justifySelf: 'left' }}>
        <UserInfo crewMember={crewMember} showBadgeNumber={true} />
      </Box>
      <Text size="300" color="grey.700" family="graphik" data-testid="ready-to-weld">
        {getStats(CommodityFilterStatusFlag.READY_TO_WELD)}
      </Text>
      <Text size="300" color="grey.700" family="graphik" data-testid="claimed">
        {getStats(CommodityFilterStatusFlag.CLAIMED)}
      </Text>
      <Text size="300" color="grey.700" family="graphik" data-testid="vt-approved">
        {getStats(CommodityFilterStatusFlag.VT_SENT_BACK)}
      </Text>
    </WelderProgressTreeItemContainerStyled>
  );
};
